import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FiLayout, FiTruck, FiBookmark, FiBox, FiCreditCard, FiBarChart2, FiSettings, FiBell, FiSearch, FiUser } from 'react-icons/fi';
import styles from './AppShell.module.css';
import IconButton from '../ui/IconButton';
import Surface from '../ui/Surface';

const NAV_ICONS = {
  FiLayout: <FiLayout />,
  FiTruck: <FiTruck />,
  FiBookmark: <FiBookmark />,
  FiBox: <FiBox />,
  FiCreditCard: <FiCreditCard />,
  FiBarChart2: <FiBarChart2 />,
  FiSettings: <FiSettings />
};

const navigationItems = [
  { label: 'Overview', path: '/dashboard', icon: 'FiLayout' },
  { label: 'Shipments', path: '/shipments', icon: 'FiTruck' },
  { label: 'Bookings', path: '/bookings', icon: 'FiBookmark' },
  { label: 'Carriers', path: '/carriers', icon: 'FiBox' },
  { label: 'Accounts Payable', path: '/accounts', icon: 'FiCreditCard' },
  { label: 'Analytics', path: '/stats', icon: 'FiBarChart2' },
  { label: 'Settings', path: '/settings', icon: 'FiSettings' }
];

const AppShell = ({ children, pageTitle, pageSubtitle, actionArea }) => {
  return (
    <div className={styles.wrapper}>
      <aside className={styles.sidebar}>
        <div className={styles.brand}>
          <div className={styles.brandMark}>
            <span className={styles.brandGradient}></span>
            <span className={styles.brandInitial}>FL</span>
          </div>
          <div>
            <span className={styles.brandName}>FreightLogic</span>
            <span className={styles.brandEdition}>Prime Console</span>
          </div>
        </div>
        <nav className={styles.navigation}>
          {navigationItems.map(({ label, path, icon }) => (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) => [styles.navItem, isActive ? styles.active : ''].filter(Boolean).join(' ')}
            >
              <span className={styles.navIcon}>{NAV_ICONS[icon]}</span>
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className={styles.contentArea}>
        <header className={styles.topBar}>
          <Surface className={styles.topBarSurface} padding="sm" tone="glass">
            <div className={styles.searchContainer}>
              <FiSearch />
              <input type="search" placeholder="Search shipments, loads, or clients" />
            </div>
            <div className={styles.topBarActions}>
              <IconButton aria-label="Notifications">
                <FiBell />
              </IconButton>
              <IconButton aria-label="Profile" className={styles.avatarButton}>
                <FiUser />
              </IconButton>
            </div>
          </Surface>
          <div className={styles.pageHeader}>
            <div>
              {pageTitle && <h1>{pageTitle}</h1>}
              {pageSubtitle && <p>{pageSubtitle}</p>}
            </div>
            {actionArea && <div className={styles.actionArea}>{actionArea}</div>}
          </div>
        </header>
        <main className={styles.mainContent}>{children}</main>
      </div>
    </div>
  );
};

AppShell.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitle: PropTypes.string,
  pageSubtitle: PropTypes.string,
  actionArea: PropTypes.node
};

export default AppShell;
